var $ = require('jquery');
var imagesLoaded = require('imagesloadedwithsize');
var isElementPartiallyInViewport = require('is-element-partially-in-viewport');
var separateElements = require('separate-elements');
var dims = require('window-dimensions');
var MQ = require('mq');



function hasNonEmptyAttribute(attribute) {
	return attribute && attribute.trim() !== '';
}

var loadAndShowElement = function(element, callback, undefined){
	// const src = [];
	// const dataSrc = element.getAttribute('data-src');
	// const dataBgSrc = element.getAttribute('data-bg-src');

	// if (hasNonEmptyAttribute(dataSrc)) {
	// 	// console.log('el', element);
	// 	src.push(dataSrc);
	// } else if (hasNonEmptyAttribute(dataBgSrc)) {
	// 	// console.log('elbg', element);
	// 	src.push(dataBgSrc);
	// }

	const src = getSrcFromElement(element);

	imagesLoaded( src, {
		background: true
	}, function() {
			updateAttributes(element);
			$(element).addClass('is-lazy-loaded');
		// alert('load done')
		// $('[data-src], [data-bg-src]').each(function(i, el){
		// 	// console.log('el', el);
		// 	if ( $(el).attr('data-bg-src')  ) {
		// 		$(el).css('background-image', 'url('+$(el).attr('data-bg-src')+')');
		// 		$(el).removeAttr('data-bg-src');
		// 	}
		// 	else {
		// 		// console.log($(el).attr('data-src'));
		// 		$(el).attr('src', $(el).attr('data-src'));
		// 		$(el).removeAttr('data-src');
		// 	}
		// });
		if ( callback !== undefined ){
			callback(element);
		}
	});
};

var canObserve = true;

var ioCallback = function(entries, ioagain){
	console.log('IO entries Img Loader', canObserve, entries);
	// var done_together = 0;
	if ( !canObserve ) {
		return;
	}
	toReveal = [];
	for(var i=0,j=entries.length;i<j;i++){
		var d = entries[i];
		// console.log('d', d);
		if ( d.isIntersecting ) {
			ioagain.unobserve( d.target );
			toReveal.push( d.target );
			// $(d.target).trigger('onreveal');
			console.log('isIntersecting', d.target);
			// done_together++;
		}
	}
	$(toReveal).each(function(index) {
		loadAndShowElement(this);
	});
};

var ioOpts = {
	/* Using default options. Details below */
	// rootMargin: '-30% 0px -15% 0px'
	rootMargin: '0px 0px 0px 0px',
	threshold: 0
	// trackVisibility: true,
	// delay: 100
};

var io = new IntersectionObserver( ioCallback, ioOpts );

function unobserveAll(observer) {
	io.takeRecords().forEach(entry => {
		observer.unobserve(entry.target);
	});
}

var otherImagesFromLoader = [];
var otherImages = [];
var loadOtherImages = function(){
	var scrollTop = window.scrollY;
	otherImagesFromLoader.forEach(el => {
		const rect = el.getBoundingClientRect();
		otherImages.push({
			element: el,
			distance: rect.top - scrollTop,
		});
	});
	// console.log('otherImages', otherImages);
	// sort element like this : [1, 8, 32, 36, 37, -3, -20, -50, -55]
	otherImages.sort(function(a, b){
		if (a.distance >= 0 && b.distance >= 0) {
			return a.distance - b.distance; // Sort positive numbers in ascending order
		} else if (a.distance < 0 && b.distance < 0) {
			return b.distance - a.distance; // Sort negative numbers in descending order
		} else {
			return a.distance >= 0 ? -1 : 1; // Put negative numbers after positive numbers
		}
	});
	// console.log('otherImages', otherImages);
	$(otherImages).each(function(index) {
		loadAndShowElement(this.element, function(el){
			// console.log('load next image', el);
			io.unobserve( el );
		});
	});
	
};

var resetOtherImagesLoad = function(){
	otherImagesFromLoader = [];
	otherImages = [];
};


module.exports = function(el, callback, callbackDelayed, delay){ // onShow
	if ( el == 'add' ){
		// return;
		$('.has-lazy-loading').not('.is-lazy-loaded').each(function(i, el){
			io.unobserve( el );
		});
		resetOtherImagesLoad();
		$('.has-lazy-loading').not('.is-lazy-loaded').get().forEach(element => {
			// $(element).addClass('has-lazy-loading');
			io.observe(element);
			otherImagesFromLoader.push( element );
		});
		loadOtherImages();
		return;
	}
	// alert('a')
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');
	console.log('ON SHOW DATA ATTR');

	resetOtherImagesLoad();

	var els = $(el).find('img[data-src], img[data-picture-src], [data-bg-src]').get();
	// if ( MQ(-767) ) {
	// 	els = $(el).find('img[data-src], img[data-picture-src], [data-bg-src]').not('.not__pho').get(); 
	// }
	// else {
	// 	els = $(el).find('img[data-src], img[data-picture-src], [data-bg-src]').not('.only__pho').get();
	// }
	console.log('els0', el, els);
	if ( els.length == 0 ){
		callback();
		setTimeout(callbackDelayed, delay);
		return false;
	}
	var final_scrolltop = 0;
	$('html, body').scrollTop(final_scrolltop);
	var isFast = false;
	// if ( isFast ){
	if ( $('html').attr('data-cymasmooth-loading') == 'none' ){
		unobserveAll();
		els.forEach(element => {
			$(element).addClass('has-lazy-loading');
			io.observe(element);
		});
		callback();
		setTimeout(callbackDelayed, delay);
		return false;
	}
	if ( $('html').attr('data-cymasmooth-loading') == 'visible' ){
		els = separateElements( els, isElementPartiallyInViewport );
	}
	else {
		els = separateElements( els, function(){return true} );
	}
	
	console.log('els', els);
	// debugger;
	

	// var src = [];
	// for(var i=0,j=els[1].length;i<j;i++){
	// 	if (els[1][i].hasAttribute('data-src') && els[1][i].getAttribute('data-src').trim() !== '') {
	// 		console.log('el', els[1][i]);
	// 		src.push(els[1][i].getAttribute('data-src'));
	// 	} else if (els[1][i].hasAttribute('data-bg-src') && els[1][i].getAttribute('data-bg-src').trim() !== '') {
	// 		console.log('elbg', els[1][i]);
	// 		src.push(els[1][i].getAttribute('data-bg-src'));
	// 	}
	// }

	const src = [];
	console.log('els[1]', els[1]);
	els[1].forEach(element => {
		// const dataSrc = element.getAttribute('data-src');
		// const dataBgSrc = element.getAttribute('data-bg-src');

		// if (hasNonEmptyAttribute(dataSrc)) {
		// 	// console.log('el', element);
		// 	src.push(dataSrc);
		// } else if (hasNonEmptyAttribute(dataBgSrc)) {
		// 	// console.log('elbg', element);
		// 	src.push(dataBgSrc);
		// }

		const elementSrc = getSrcFromElement(element);
		console.log('elementSrc', elementSrc);
		src.push(...elementSrc);
	});

	console.log('src', src);

	unobserveAll();
	// console.log('els[0]', els[0]);
	// debugger;
	els[0].forEach(element => {
		$(element).addClass('has-lazy-loading');
		io.observe(element);
		otherImagesFromLoader.push( element );
	});

	if ( src.length == 0 ){ // no image in viewport
		loadOtherImages();
		callback();
		setTimeout(callbackDelayed, delay);
		return false;
	}

	// $(el).find('img[data-src]').each(function(i, el){ // add img to avoid pb with fancybox cause it use data-src too
	// 	console.log('el', el);
	// 	src.push( $(el).attr('data-src') );
	// })
	// $(el).find('[data-bg-src]').each(function(i, el){
	// 	console.log('elbg', el);
	// 	src.push( $(el).attr('data-bg-src') );
	// })
	// console.log('src', src);

	// debugger;

	imagesLoaded( src, {
		background: true
	}, function() {
		els[1].forEach(element => {
			updateAttributes(element);
		});
		// alert('load done')
		// $('[data-src], [data-bg-src]').each(function(i, el){
		// 	// console.log('el', el);
		// 	if ( $(el).attr('data-bg-src')  ) {
		// 		$(el).css('background-image', 'url('+$(el).attr('data-bg-src')+')');
		// 		$(el).removeAttr('data-bg-src');
		// 	}
		// 	else {
		// 		// console.log($(el).attr('data-src'));
		// 		$(el).attr('src', $(el).attr('data-src'));
		// 		$(el).removeAttr('data-src');
		// 	}
		// });
		loadOtherImages();
		callback();
		setTimeout(callbackDelayed, delay);
	});

	return true;
};

var updateAttributes = function(element) {
	const dataSrc = element.getAttribute('data-src');
	const dataBgSrc = element.getAttribute('data-bg-src');
	const dataSrcSet = element.getAttribute('data-srcset');
	const dataSrcSetSrc = element.getAttribute('data-srcset-src');
	const dataPictureSrc = element.getAttribute('data-picture-src');

	if (hasNonEmptyAttribute(dataPictureSrc)) {
		element.src = dataPictureSrc;
		$(element).siblings('source').each(function(i, el){
			$(el).attr('srcset', $(el).attr('data-picture-srcset'));
			$(el).removeAttr('data-picture-srcset');
		});
		element.removeAttribute('data-picture-src');
	} 
	else if (hasNonEmptyAttribute(dataSrcSet)) {
		element.src = dataSrcSetSrc;
		element.setAttribute('srcset', dataSrcSet);
		element.removeAttribute('data-src');
		element.removeAttribute('data-srcset');
		element.removeAttribute('data-srcset-src');
	} 
	else if (hasNonEmptyAttribute(dataSrc)) {
		element.src = dataSrc;
		element.removeAttribute('data-src');
	} 
	else if (hasNonEmptyAttribute(dataBgSrc)) {
		element.style.backgroundImage = 'url(' + dataBgSrc + ')';
		element.removeAttribute('data-bg-src');
	}
};

function getSrcFromElement(element) {
	const src = [];
	const dataSrc = element.getAttribute('data-src');
	const dataBgSrc = element.getAttribute('data-bg-src');
	const dataSrcSet = element.getAttribute('data-srcset');
	const dataPictureSrc = element.getAttribute('data-picture-src');

	if ( hasNonEmptyAttribute(dataPictureSrc) ){
		const urls = $(element).siblings('source').get().map(entry => {
	        // Supprime les espaces de début et de fin, et retire la largeur à la fin de chaque entrée
	        return entry.getAttribute('data-picture-srcset');
	    });
		const breakpoints = $(element).siblings('source').get().map(entry => {
	        // Supprime les espaces de début et de fin, et retire la largeur à la fin de chaque entrée
	        return parseInt( entry.getAttribute('data-mq'), 10 );
	    });
	    console.log('breakpoints', breakpoints);
	    // if ( dims.w <= 480 ){
	    // 	src.push(urls[0]);
	    // }
	    // else if ( dims.w <= 768 ){
	    // 	src.push(urls[1]);
	    // }
	    // else if ( dims.w <= 1280 ){
	    // 	src.push(urls[2]);
	    // }
	    // else{
	    // 	src.push(urls[3]);
	    // }
	    // const breakpoints = [480, 768, 1280];
		const index = breakpoints.findIndex((breakpoint) => dims.w <= breakpoint);
		const url = urls[index === -1 ? urls.length - 1 : index];
		console.log('indexp', index, url, dims.w);
		src.push(url);
		element.setAttribute('data-picture-src', url);
	}
	else if (hasNonEmptyAttribute(dataSrc)) {
		// console.log('el', element);
		if ( hasNonEmptyAttribute(dataSrcSet) ){
			const urls = dataSrcSet.split(',').map(entry => {
		        // Supprime les espaces de début et de fin, et retire la largeur à la fin de chaque entrée
		        return entry.trim().split(' ')[0];
		    });
		    // if ( dims.w <= 480 ){
		    // 	src.push(urls[0]);
		    // }
		    // else if ( dims.w <= 768 ){
		    // 	src.push(urls[1]);
		    // }
		    // else if ( dims.w <= 1280 ){
		    // 	src.push(urls[2]);
		    // }
		    // else{
		    // 	src.push(urls[3]);
		    // }
		    // const breakpoints = [480, 768, 1280];
		    const breakpoints = [768, 1024, 1600];
			const index = breakpoints.findIndex((breakpoint) => dims.w * window.devicePixelRatio <= breakpoint);
			const url = urls[index === -1 ? urls.length - 1 : index];
			console.log('indexs', index, url, dims.w);
			src.push(url);
			element.setAttribute('data-srcset-src', url);
		}
		else {
			src.push(dataSrc);
		}
	} 
	else if (hasNonEmptyAttribute(dataBgSrc)) {
		// console.log('elbg', element);
		src.push(dataBgSrc);
	}

	return src;
}

